import React from "react";
import PropTypes from "prop-types";
import SummaryItem from "../components/SummaryItem.jsx";
import SectionItem from "../components/SectionItem.jsx";
import { ServiceLink } from "../components/ServiceLink.jsx";
import AudioFile from "../components/AudioFile.jsx";
import { Voicemail } from "../components/Voicemail.jsx";
import * as CONST from "../constants";
import DestinationGroup from "../components/DestinationGroup.jsx";

const Callshield = (props) => {
  const { module } = props;
  return (
    <SummaryItem itemKey={"Callshield: "}>
      <SectionItem itemKey={"Threshold calls"}>
        {module.thresholdCalls}
      </SectionItem>
      <SectionItem itemKey={"Threshold time"}>
        {CONST.ThresholdOptions[module.thresholdTime]}
      </SectionItem>
      <SectionItem itemKey="Divert Calls to">
        {CONST.CallerExceptionAction[module.callshieldExceptionAction]}
      </SectionItem>
      {module.callshieldExceptionAction === 1 && (
        <SectionItem itemKey="Divert Destination">
          <DestinationGroup
            group={module}
            sites={props.sites}
            clientId={props.clientId}
          />
        </SectionItem>
      )}
      {module.callshieldExceptionAction === 2 && (
        <SectionItem itemKey="Divert Audio">
          <AudioFile audioId={module.audio} />
        </SectionItem>
      )}
      {module.callshieldExceptionAction === 5 && (
        <SectionItem itemKey="Divert Service">
          <ServiceLink service={module.moduleGroupOption} />
        </SectionItem>
      )}
      {module.callshieldExceptionAction === 8 && (
        <Voicemail config={module.voicemail} />
      )}
    </SummaryItem>
  );
};

export default Callshield;

Callshield.propTypes = {
  module: PropTypes.object,
  sites: PropTypes.array,
  clientId: PropTypes.any,
};
